import React from "react";
import "../App.css";
import Fire from "../config/Fire";
//import {InfiniteLoading} from 'react-simple-infinite-loading'
import InfiniteScroll from 'react-infinite-scroll-component';
import RenderComment from "../utils/RenderComment";
import { Link } from 'react-router-dom'
import Aux from "../utils/AuxFunctions";
import LikeOutlineIcon from "mdi-react/HeartOutlineIcon"
import LikeFilledIcon from "mdi-react/HeartIcon"
import moment from "moment"
import Colors from "../utils/Colors";
import { withMyDataContext } from "../context/DataProvider";
import PlusIcon from "mdi-react/PlusIcon"
import MinusIcon from "mdi-react/MinusIcon"
import ChevronUp from "mdi-react/ChevronUpIcon"
import PencilIcon from "mdi-react/PencilIcon"
import ErrorMessage from "../utils/ErrorPages/ErrorMessage";
import ButtonLoader from "../utils/Utilities/ButtonLoader";
import NotLoggedIn from "../utils/ErrorPages/NotLoggedIn";
import Loader from "../utils/Utilities/Loader";
import EditPostModal from "../create/EditPostModal";
import NumberFormat from "react-number-format";
import TextInputMaterial from "../utils/Utilities/TextInputMaterial";

const LIMIT = 10;
const TYPE = "postComments"
class ViewPost extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            commentsData: [],
            lastVisible: null,
            finished: false,
            loading: false,
            loadingPost: false,
            id: this.props.match.params.id,
            post: {},
            noPost: false,
            loadingCreatingComment: false,
            coins: 0,
            commentText: "",
            commentError: "",
            loginDialog: false,
            isCommentOpen: false,
            editModal: false,
            loadedLikes: false,
            loadingLike: false,
            hasToCheckLike: false,
        }
    }

    componentDidMount() {
        try {
            if (this.props.location.state?.post) {
                this.setState({ post: this.props.location.state?.post })
                this.getAllData();
                if(!this.props.location.state.loadedLikes){
                    this.checkIfLiked(this.props.match.params.id)
                }else{
                    this.setState({loadedLikes:true})
                }
            }else if (this.props.match.params.id) {
                this.getPostInfo();
                
                this.getAllData();
            } else {
                this.setState({ noPost: true })
            }

        } catch (error) {
            Aux.handleError(error)
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.myDataProvider.user !== prevProps.myDataProvider.user && this.state.hasToCheckLike) {
            if(!this.props.location.state?.loadedLikes){
                this.checkIfLiked(this.props.match.params.id)
            }
                
        }
    } 

    getTime = () => {
        try {
            if (this.state.post?.timestamp) {
                var time = moment(this.state.post.timestamp.toDate()).fromNow();
                return time || "unknown";
            } else {
                return "unknown"
            }
        } catch (error) {
            Aux.handleError(error)
            return "unknown"
        }
    }

    checkIfLiked = async (id) => {
        try {
            if (!Fire.shared.uid) {
                this.setState({hasToCheckLike:true})
                return;
            }
            await Fire.shared.firestore.collection(`users/${Fire.shared.uid}/likes`)
                .where("postid", "==", id).get().then(data => {
                    if (!data.empty) {
                        let newPost = this.state.post
                        newPost.liked = true
                        this.setState({post:newPost})
                        /* this.setState(prevState => ({
                            post: {                   // object that we want to update
                                ...prevState.post,
                                liked: true,
                            }
                        })) */
                    } else {
                        let newPost = this.state.post
                        newPost.liked = false
                        this.setState({post:newPost})
                        //no like
                    }
                    this.setState({loadedLikes: true, hasToCheckLike: false})
                })
        } catch (error) {
            Aux.handleError(error)
        }
    }

    getPostInfo = async () => {
        try {
            this.setState({loadingPost: true})
            const post = await Fire.shared.getPostInfo(this.props.match.params.id)
            if (post) {
                var newPost = post;
                newPost.id = this.props.match.params.id
                this.setState({ post: newPost, loadingPost:false, myPost: newPost })
                await this.checkIfLiked(this.props.match.params.id)
            }else{
                this.setState({ noPost: true, loadingPost:false })
            }
            
        } catch (error) {
            this.setState({ noPost: true, loadingPost:false })
            Aux.handleError(error)
        }
    }

    ChangeToogleLike = (liked) => {
        try {
            this.setState(prevState => ({
                post: {                   // object that we want to update
                    ...prevState.post,
                    liked: liked,
                    likesCount: liked ? prevState.post.likesCount + 1 : prevState.post.likesCount - 1,
                }
            }))
        
        } catch (error) {
            Aux.handleError(error)
        }
    }

    ToogleLikePost = async () => {
        try {
            if (!this.props.myDataProvider.user) {
                this.setState({ loginDialog: true })
            }
            if(!this.state.loadedLikes)
                return

            if(this.state.loadingLike){
                return
            }
            this.setState({loadingLike: true})
            
            if(this.props.myDataProvider.user?.role === "admin" || this.props.myDataProvider.user?.role === "dummy"){
                this.ChangeToogleLike(true);
                Fire.shared.LikePostAdmin(this.state.post)
                
            }else{
                if (this.state.post.liked) {
                    this.ChangeToogleLike(false);
                } else {
                    this.ChangeToogleLike(true);
                }
                await Fire.shared.toogleLikePost(this.state.post);
            }
            this.setState({loadingLike: false})
        } catch (error) {
            Aux.handleError(error);
            this.setState({loadingLike: false})
        }
    }

    getAllData = async () => {
        if (this.state.loading) return;

        try {
            this.setState({ loading: true })
            Fire.shared
                .GetPostsData(TYPE, this.state.lastVisible, LIMIT, this.props.match.params.id)
                .then(snapshot => {
                    if (snapshot) {

                        if (snapshot.length < LIMIT || snapshot.empty) {
                            this.setState({ finished: true })
                        }

                        let data = snapshot.docs.map(document => {
                            const doc = document.data();
                            doc.id = document.id;
                            return doc;
                        });

                        this.setState({
                            commentsData: [...this.state.commentsData, ...data],
                            lastVisible: snapshot.docs[snapshot.docs.length - 1],
                            loading: false,
                        });
                    } else {
                        this.setState({ finished: true, loading: false })
                    }
                });
        } catch (error) {
            Aux.handleError(error)
        }
    };

    handleIncrementCoin = () => {
        if (this.state.coins + 1 >= this.props.myDataProvider.coins) {
            this.setState({ coins: this.props.myDataProvider.coins })
        } else if (!this.state.coins && this.props.myDataProvider.coins > 0) {
            this.setState({ coins: 1 })
        } else if (!this.state.coins) {
            this.setState({ coins: 0 })
        } else {
            this.setState(prevState => ({ coins: prevState.coins + 1 }));
        }
    }

    handleDecrementCoin = () => {
        if (!this.state.coins || this.state.coins < 0) {
            this.setState({ coins: 0 })
        } else {
            this.setState(prevState => ({ coins: prevState.coins - 1 }));
        }
    }

    handleCoinsSlider = (event) => {
        let num = parseInt(event.target.value, 10)
        this.setState({ coins: num });
    }

    createComment = async () => {
        if (this.state.loadingCreatingComment)
            return;
        if (!this.state.post)
            return;

        this.setState({ loadingCreatingComment: true, commentError: "" })

        if (this.props.myDataProvider.coins <= 0) {
            this.setState({ loadingCreatingComment: false, commentError: "add some balance to your account" })
            return;
        }
        if (this.state.coins <= 0) {
            this.setState({ loadingCreatingComment: false, commentError: "minimum amount is 1$" })
            return;
        }

        else {
            if (this.state.commentText.lenght > 300) {
                this.setState({ loadingCreatingComment: false, commentError: "too long, maximum 300 characthers" })
                return;
            } else {
                try {
                    await Fire.shared.addNewComment({
                        post: this.state.post,
                        text: this.state.commentText,
                        coins: this.state.coins
                    }).then((didComment) => {
                        if (didComment) {
                            let commentt = {};
                            commentt.uid = Fire.shared.uid
                            commentt.timestamp = Date.now()
                            commentt.text = this.state.commentText
                            commentt.coins = this.state.coins
                            commentt.postid = this.state.post.id

                            this.addComment(commentt)
                            this.setState({ commentOpen: false, commentText: "", coins: 0, loadingCreatingComment: false })
                        } else {
                            this.setState({ loadingCreatingComment: false, commentError: "an unexpected error occurred" })
                        }
                    })

                } catch (error) {
                    Aux.handleError(error)
                    this.setState({ loadingCreatingComment: false, commentError: "an unexpected error occurred" })
                }
            }
        }
    }

    addComment = (comment) => {
        let post = this.state.post
        post.commentCount = post.commentCount + 1;
        post.commentCoins = post.commentCoins + comment.coins;
        post.coins = post.coins + comment.coins;
        this.setState({
            commentsData: [...this.state.commentsData, comment],
            post: post
        });

    }
    
    renderNoPost = () => {
        return (
            <div style={{ display: "flex", justifyContent: "center", marginTop: 30 }}>
                <span> The Post is currently unavailable...</span>
            </div>
        )
    }

    renderCreateComment = () => {
        return (
            <div style={{}}>
                {this.props.myDataProvider.user ?
                    <div style={{ display: "flex", flexDirection: "column", padding: "20px 30px", borderRadius: "5px 5px 0 0", backgroundColor: "#f8f8f8", }}>
                        <ErrorMessage text={this.state.commentError}></ErrorMessage>
                        {this.props.myDataProvider.coins <= 0 ? (
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginBottom:10 }}>
                                  <Link to={`/account/balance`} style={{ textDecoration: "none", overflow:"hidden" }} className="text-hover">
                                <span style={{color:"#777"}}>You need to <span style={{color:Colors.mainColor, fontWeight:"bold"}}>add</span> some balance to continue</span>
                              
                                    
                                </Link>
                            </div>
                        ) : (
                                <div>
                                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                                        <span style={{ color: "#ccc" }}>The comment value is added to the original post</span>
                                        <ChevronUp className="button-hover" onClick={() => this.setState({ isCommentOpen: false })}></ChevronUp>
                                    </div>
                                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", marginTop: 5, marginBottom: 10 }}>
                                        <span style={{ color: Colors.darkText, fontWeight: "700", }}>Amount to spend?</span>
                                        <NumberFormat 
                                        placeholder="0,00" 
                                        className="add-coins-input"  
                                        value={this.state.coins} 
                                        thousandSeparator={true} prefix={'$'} 
                                        allowNegative={false} 
                                        decimalScale={0}
                                        style={{textAlign:"right", backgroundColor:"rgb(248, 248, 248)"}}
                                        onValueChange={(values) => {
                                            const { floatValue} = values;
                                            var myValue = floatValue
                                            var currentCoins = this.props.myDataProvider.user?.coins || 0
                                            if(floatValue > currentCoins ){
                                                myValue = currentCoins
                                            }
                                            this.setState({coins: myValue})
                                        }}/>
                                        {/* <h3 style={{ color: Colors.darkText, fontWeight: "bold", marginLeft: 10, }}>{this.state.coins || 0}.00$</h3> */}
                                    </div>
                                    <div className="slidecontainer" style={{ display: "flex", alignItems: "center", marginBottom: 10 }}>

                                        <MinusIcon className="coins-icon" style={{ minWidth: 24, minHeight: 24 }} onClick={this.handleDecrementCoin}></MinusIcon>

                                        <input type="range"
                                            // defaultValue={0} 
                                            style={{ margin: "0 10px" }}
                                            min={0}
                                            max={this.props.myDataProvider.coins}
                                            step={1}
                                            value={this.state.coins}
                                            className="slider"
                                            onChange={this.handleCoinsSlider}
                                        />

                                        <PlusIcon className="coins-icon" style={{ minWidth: 24, minHeight: 24 }} onClick={() => this.handleIncrementCoin(1)}></PlusIcon>

                                    </div>
                                </div>)}
                        <div style={{ display: "flex", width: "100%" }}>

                            <TextInputMaterial type="text" rows="3" placeholder="Insert text here" multiline={true}
                                style={{width:"100%"}}
                                styleInput={{ resize: "none", height: "auto", paddingTop: 10, marginBottom: 10 }}
                                onChange={(e) => {
                                    this.setState({ commentText: e.target.value });
                                }}/>

                        </div>
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                            {Aux.showAvatar(40, this.props.myDataProvider.user.avatar, this.props.myDataProvider.user.username || "Unknown")}
                            <ButtonLoader
                                text="Post"
                                onClick={this.createComment}
                                loading={this.state.loadingCreatingComment}
                                style={{ backgroundColor: Colors.mainColor, padding: "0.5rem 2rem", marginLeft: 20 }}
                            />
                        </div>
                    </div> : null}
            </div>
        )
    }

    getRoundCoins = (coins) => {
        try {
            if(coins < 0)
                return 0
            else
                return Math.round( coins * 10 + Number.EPSILON ) / 10
        } catch (error) {
            Aux.handleError(error)
        }
    }
    
    render() {
        const isMyPost = this.state.post.uid === Fire.shared.uid
        return (
            <div ref={this.myRef} id={"Header"} className="content-home" style={{ /* backgroundColor: "#ECEFF1", */ display: "flex", flexDirection: "column", width: "100%", marginBottom: 30, marginTop: 20, marginLeft:10, marginRight:10 }}>
                {this.state.noPost ? 
                <div style={{display:"flex", justifyContent:"center", marginTop:20}}>
                    <span>No post was found...</span>
                </div> :
                this.state.loadingPost ? 
                <div style={{display:"flex", justifyContent:"center", marginTop:20}}>
                    <Loader></Loader>
                </div> :
                <div>
                    <NotLoggedIn active={this.state.loginDialog} onClose={() => this.setState({ loginDialog: false })}></NotLoggedIn>
                    <EditPostModal  active={this.state.editModal} onClose={() => this.setState({ editModal: false })} post={this.state.post}></EditPostModal>
                    <div>
                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center",  margin:"0px 10px", marginBottom:10, }}>
                            <div style={{display:"flex", alignItems:"center", overflow:"hidden"}}>
                            {this.state.post.hide ?
                                <div style={{display:"flex", alignItems:"center" }}>
                                    {Aux.showHidden(50)}
                                    <span style={{ /* color: "#ffa100", */ color: Colors.softText, fontWeight: "bold", marginLeft: 10, overflowWrap: "anywhere", display:"flex" }}>
                                        Anonymous
                                    </span>
                                </div>
                                :
                                <Link to={`/user/${this.state.post.username}`} style={{ textDecoration: "none", overflow:"hidden" }}>
                                    <div style={{ display: "flex", flexDirection: "row", alignItems:"center", overflow:"hidden" }}>
                                        {Aux.showAvatar(50, this.state.post.avatar, this.state.post.username || "Unknown")}
                                        <span style={{marginLeft:10, alignSelf: "center", color: Colors.darkText, fontWeight:"bold", textOverflow:"ellipsis", overflow:"hidden"}}>@{this.state.post.username || "Unknown"}</span>
                                </div>
                                </Link>
                            }
                            
                            </div>
                            <h3 style={{ marginRight: 10 }}>{this.getRoundCoins(this.state.post.coins) || 0}$</h3>
                        </div>
                        <div>
                            <div style={{ display: "flex", justifyContent: "flex-start", margin: 0 }}>
                                {this.state.post.text ?
                                    <span style={{ margin: 0, marginLeft: 10, color: "black",  whiteSpace: "break-spaces"}}>{this.state.post.text}</span>
                                    : null
                                }
                            </div>
                            <div style={{ margin: 0, padding: 0 }}>
                                {this.state.post.image ?
                                    <img alt="Avatar" src={this.state.post.image || ""} style={{ width: "100%", borderRadius: 20, marginTop: 10 }}></img>
                                    : null
                                }
                            </div>
                        </div>
                        <div style={{ display: "flex", flexDirection: "row", flexWrap:"wrap", justifyContent: "flex-start", marginLeft: 10, alignItems: "center", color: Colors.softText, marginTop: 10 }} >

                            {this.state.post.hashtag ?
                                <div style={{display:"flex", alignItems:"center"}}>
                                    <Link to={`/hashtag/${this.state.post.hashtag}`} style={{ textDecoration: "none", color:Colors.middleText, fontWeight:"bold" }} className="text-hover">
                                        #{this.state.post.hashtag}
                                    </Link>
                                    <div style={{ height: 5, width: 5, borderRadius: "50%", backgroundColor: Colors.softText, margin: "0 10px" }}></div>
                                </div> : null}
                            <span style={{}}>
                                {this.getTime()}
                            </span>
                            <div style={{ height: 5, width: 5, borderRadius: "50%", backgroundColor: Colors.softText, margin: "0 10px" }}></div>
                            <span style={{marginRight:10}}>
                                started at ${this.state.post.startCoins || 0}
                            </span>
                            {isMyPost ? 
                            <div onClick={() => this.setState({editModal:true})} className="text-hover" style={{display:"flex", alignItems:"center", backgroundColor:Colors.softText, padding:"4px 10px", borderRadius:10, }}> 
                                <span  style={{color: "white", marginRight:5}}>Edit Post</span>
                                <PencilIcon size={16} color={"white"}></PencilIcon>
                            </div> : null}
                            {this.props.myDataProvider.user?.role === "admin" ?
                            <div onClick={() => {Fire.shared.deletePost(this.state.post.id)}} className="text-hover" style={{display:"flex", alignItems:"center", }}> 
                                <span  style={{color: "red", marginRight:5}}>DELETE</span>
                            </div> : null}
                        </div>
                        
                    </div>
                    <div className="full-shadow" style={{ backgroundColor: "white", margin: "20px 0", borderRadius: 5, padding: "20px 0" }}>

                        <div style={{ display: "flex", margin: "0 20px", marginBottom: 10, justifyContent:"space-between",  alignItems: "center", flexWrap:"wrap"}}>
                            <div style={{display:"flex", }}>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    {this.state.post.liked ?
                                        <LikeFilledIcon className="post-like" size="30" color={Colors.mainColorText} style={{ marginRight: 10 }} onClick={this.ToogleLikePost}></LikeFilledIcon>
                                        :
                                        <LikeOutlineIcon className="post-like" size="30" color={Colors.middleText} style={{ marginRight: 10 }} onClick={this.ToogleLikePost}></LikeOutlineIcon>
                                    }
                                    <h3 style={{ color: Colors.middleText }}>{this.state.post.likesCount || 0} likes</h3>
                                </div>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <h3 style={{ color: Colors.middleText, marginLeft: 40 }}>
                                        {this.state.post.commentCount || 0} Comments
                                    </h3>
                                    <span style={{ color: Colors.softText, marginLeft: 7 }}>
                                        (+{this.getRoundCoins(this.state.post.commentCoins || 0) }$)
                                    </span>
                                </div>
                            </div>
                            {/* <div style={{display:"flex"}}>
                                <span style={{ color: Colors.softText, marginLeft: 7 }}>
                                    (+{this.getRoundCoins(postValue || 0)}$)
                                </span>
                            </div> */}
                        </div>
                        {this.state.isCommentOpen ?
                            <this.renderCreateComment></this.renderCreateComment>
                            :
                            <div style={{ border: "2px solid #f9f9f9", backgroundColor: "#f8f8f8", borderRadius: 5, margin: "10px 0" }}>
                                {this.props.myDataProvider.user ?
                                    <div className="reversed-button-hover" onClick={() => this.setState({ isCommentOpen: true })}>
                                        <div style={{ display: "flex", alignItems: "center", padding: "10px 20px" }}>
                                            {Aux.showAvatar(40, this.props.myDataProvider.user.avatar, this.props.myDataProvider.user.username || "Unknown")}
                                            <span style={{ marginLeft: 20, color:Colors.middleText }}>Click here to comment...</span>
                                        </div>
                                    </div>
                                    :
                                    <div style={{ display: "flex", alignItems: "center", padding: "10px 20px" }}>
                                        <span style={{marginLeft:10}}>You have to &nbsp; </span>
                                        <Link to={"/account/login"} style={{textDecoration:"none", color: Colors.mainColor}}>
                                         Login
                                        </Link>
                                        <span style={{marginLeft:10}}> to comment...</span>
                                    </div>
                                }
                            </div>}

                        <InfiniteScroll
                            style
                            dataLength={this.state.commentsData.length}
                            next={this.getAllData}
                            hasMore={!this.state.finished}
                            loader={<div style={{ marginTop: 20 }}><Loader color={"#999"}></Loader></div>}

                            endMessage={
                                <div style={{ marginTop: 20 }}>
                                    {this.state.commentsData.length <= 0 ?
                                        <p style={{ textAlign: 'center', marginTop: 20 }}>
                                            <b>there are no comments yet</b>
                                        </p> : null
                                    }
                                </div>

                            }
                        >
                            {this.state.commentsData.map((item, index) => (
                                <RenderComment comment={item} key={item.id + index} styles={this.props.styles}></RenderComment>
                            ))}
                        </InfiniteScroll>
                    </div>
                </div>}
            </div>
        );
    }
}

export default withMyDataContext(ViewPost);